import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

const textStyle = (weight: number) => ({
  fontFamily: "Manrope",
  fontSize: 14,
  fontWeight: weight,
  lineHeight: "20px",
  letterSpacing: 0.1,
  color: colors.gray600,
});

export const IconButtonWrapper = styled("div")(() => ({
  marginBottom: 10,
  marginLeft: 34,
}));

export const ViewWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: 1,
  "& label": {
    ...textStyle(600),
  },

  "& span": {
    ...textStyle(400),
  },
}));

const styles = makeStyles(() => ({
  mt2: {
    marginTop: "0.55rem",
  },
  wrapper: {
    padding: "8px 8px 20px 8px",
  },
  p0: {
    padding: 0,
  },
  dflex_h100: {
    display: "flex",
    height: "100%",
  },
}));

export default styles;
